module.exports = __webpack_public_path__ + "static/media/studio-collect.acf0e1be.svg";